import React from 'react';
import css from './SideNav.module.css';
import SideNavItem from '../SideNavItem/SideNavItem';
const SideNav = props => {
  const { currentPage } = props;
  const buttons = [
    {
      label: 'My listings',
      namedLinkProps: { name: 'ManageListingsPage' },
    },
    {
      label: 'My watchlist',
      namedLinkProps: { name: 'FavListingsPage' },
    },
    {
      label: 'List an item',
      namedLinkProps: { name: 'NewListingPage' },
    },
    {
      label: 'My purchases',
      namedLinkProps: { name: 'InboxPage', params: { tab: 'orders' } },
    },
    {
      label: 'My sales & enquiries',
      namedLinkProps: { name: 'InboxPage', params: { tab: 'sales' } },
    },
    // {
    //   label: 'Recently viewed',
    //   disabled: true,
    // },
    {
      label: 'Profile settings',
      namedLinkProps: { name: 'ProfileSettingsPage' },
    },
    {
      label: 'Account settings',
      namedLinkProps: { name: 'ContactDetailsPage' },
    },
  ];
  return (
    <nav className={css.wrapper}>
      {buttons.map(b => (
        <SideNavItem {...b} isSelected={currentPage === b?.namedLinkProps?.name} />
      ))}
    </nav>
  );
};

export default SideNav;
